import React from 'react';
import { Box, Button, Typography } from '@mui/material';

// A throw during render unmounts the whole tree and leaves a blank page with
// nothing but a console message. This catches it so the failure is visible and
// the user has a way back, instead of a white screen.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled render error:', error, info.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <Box sx={{ maxWidth: 720, mx: 'auto', mt: 10, px: 3 }}>
        <Typography variant="h5" fontFamily="'Work Sans', sans-serif" fontWeight={700} gutterBottom>
          Something went wrong on this page
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>
          The rest of the app is still working — try going back to the home page.
          If this keeps happening, send this message to the team:
        </Typography>
        <Box
          component="pre"
          sx={{
            bgcolor: '#f5f6fa',
            border: '1px solid #e0e0e0',
            borderRadius: 2,
            p: 2,
            mb: 3,
            fontSize: 13,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          }}
        >
          {error.name}: {error.message}
        </Box>
        <Button
          variant="contained"
          onClick={() => { window.location.href = '/'; }}
          sx={{ textTransform: 'none', borderRadius: 2 }}
        >
          Back to home
        </Button>
      </Box>
    );
  }
}

export default ErrorBoundary;
